var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7086",
    "data-name": "Group 7086",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6546",
    "data-name": "Group 6546"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 5.376,
    cy: 5.376,
    r: 5.376,
    transform: "translate(61.824 54.624)",
    fill: "#1648c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M25.512,17.5c-3.5,0-10.512,1.728-10.752,5.184a13.1,13.1,0,0,0,21.5,0C36.024,19.228,29.016,17.5,25.512,17.5Z",
    transform: "translate(41.688 52.1)",
    fill: "#1648c6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M75,41.832V18.7L39,3,3,18.7V42.264C3,64.056,18.36,84.456,39,89.4a44,44,0,0,0,7.68-2.64A28.778,28.778,0,1,0,75,41.832ZM41.4,70.2a27.676,27.676,0,0,0,1.1,7.776,31.619,31.619,0,0,1-3.5,1.44c-15.216-4.8-26.4-20.352-26.4-37.152V24.984L39,13.464l26.4,11.52V41.832A28.788,28.788,0,0,0,41.4,70.2ZM70.2,89.4A19.2,19.2,0,1,1,89.4,70.2,19.195,19.195,0,0,1,70.2,89.4Z",
    transform: "translate(-3 -3)",
    fill: "#1648c6",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueShield);
export default __webpack_public_path__ + "static/media/blue_shield.1e2d32d2a6751f702c0828c0beb97dca.svg";
export { ForwardRef as ReactComponent };